"use strict";

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.didYouMean = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _core = require("@orbital-frame/core");

var _damerauLevenshtein = _interopRequireDefault(require("talisman/metrics/distance/damerau-levenshtein"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaults = {
  sensitivity: 2
};

var didYouMean = function didYouMean(options) {
  return function (_ref) {
    var commandService = _ref.commandService,
        messengerService = _ref.messengerService;
    return _defineProperty({}, _core.phase.EXECUTE, {
      error: function error(e, _ref2) {
        var context = _ref2.context;
        if (!(e instanceof _core.error.CommandNotFoundError)) return;

        var _objectSpread2 = _objectSpread({}, defaults, {}, options),
            sensitivity = _objectSpread2.sensitivity;

        var command = context.message.text.split(/\s+/).splice(1).join(' ');
        var matches = Object.keys(commandService.registry).map(function (name) {
          var distance = (0, _damerauLevenshtein.default)(command, name);
          return {
            name: name,
            distance: distance
          };
        }).filter(function (_ref3) {
          var distance = _ref3.distance;
          return distance <= sensitivity;
        });

        if (matches.length > 0) {
          messengerService.respond(context, "Did you mean:\n".concat(matches.map(function (_ref4) {
            var name = _ref4.name;
            return "    ".concat(name);
          }).join('\n')));
        }
      }
    });
  };
};

exports.didYouMean = didYouMean; // configurable

var _default = didYouMean(); // use only default configuration


exports.default = _default;